export default __webpack_public_path__ + "static/media/MPCAS_Univas.c3b17819.png";